import { Injectable, Injector } from '@angular/core';
import { InveniasTriggerConfigService } from '../../components/workflow-config/actions/actionConfigs/invenias-trigger-config.service';
import { ITriggerConfigService } from '../../components/workflow-config/actions/actionConfigs/itriggerconfig.service';
import { IDocMergeAllowedEntitiesService } from '../../components/workflow-config/allowedEntities/IDocMergeAllowedEntitiesService';
import { IDocMergeAllowedSectionsService } from '../../components/workflow-config/allowedSections/IDocMergeAllowedSectionsService';
import { ISignatureDataFormatterService } from '../../interfaces/ISignatureDataFormatterService';
import { IDocumentDestinationService } from '../../model/interfaces/idocumentdestinationservice';
import { IAttachmentSourceOptionLabelService } from '../attachment-source-options/iattachment-source-option-label.service';
import { InveniasAttachmentSourceOptionLabelService } from '../attachment-source-options/invenias-attachment-source-option-label.service';
import { InveniasDocumentDestinationService } from '../document-destination/invenias.document-destination.service';
import { InveniasSignatureFormatterService } from '../signature-formatters/invenias-signature-formatter.service';
import { IServiceProviderService } from './iserviceproviderservice';

@Injectable({ providedIn: 'root' })
export class InveniasServiceProviderService implements IServiceProviderService {
  constructor(private injector: Injector) {}

  getDocumentDestinationService(): IDocumentDestinationService {
    return this.injector.get(InveniasDocumentDestinationService);
  }

  getSignatureDataFormatterService(): ISignatureDataFormatterService {
    return this.injector.get(InveniasSignatureFormatterService);
  }

  getTriggerConfigService(): ITriggerConfigService {
    return this.injector.get(InveniasTriggerConfigService);
  }

  getDocMergeAllowedEntitiesService(): IDocMergeAllowedEntitiesService {
    return null;
  }

  getDocMergeAllowedSectionsService(): IDocMergeAllowedSectionsService {
    return null;
  }

  getAttachmentSourceOptionLabelService(): IAttachmentSourceOptionLabelService {
    return this.injector.get(InveniasAttachmentSourceOptionLabelService);
  }
}
